import { createQueryKeys } from "@lukemorales/query-key-factory";
import axios from "axios";
import { MenuHierarchiesApi } from "mws-ts-v2-sdk";
import { unref } from "vue";

const getMenuHierarchiesApi = () => {
  return new MenuHierarchiesApi(
    undefined,
    useRuntimeConfig().public.catalogServiceUrl,
    axios,
  );
};
export const menuHierarchyQueryKeys = createQueryKeys("menuHierarchies", {
  treeForIdsWithLiveEvents: (
    menuHierarchyId: MaybeRef<string>,
    xPlatformKey: MaybeRef<string>,
  ) => ({
    queryKey: [menuHierarchyId],
    queryFn: async () => {
      const response = await getMenuHierarchiesApi().v2MenuHierarchiesGet({
        xPlatformKey: unref(xPlatformKey),
        menuHierarchyIds: unref(menuHierarchyId),
        includeLiveEvents: true,
      });

      return response.data;
    },
  }),
});
